import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	accessForbiddenTitle: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.access-forbidden-title',
		defaultMessage: 'Join an Opsgenie team',
		description: 'Title to be displayed when the user does not have access to Opsgenie',
	},
	accessForbiddenBody: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.access-forbidden-body',
		defaultMessage:
			'Ask your Opsgenie admin for an invitation to start using on-call and incident management features in this project.',
		description: 'Text to be displayed when the user does not have access to Opsgenie',
	},
	createScheduleTitle: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.create-schedule-title',
		defaultMessage: 'See your first schedule in Jira',
		description: 'Title to be displayed when there are no Opsgenie schedules.',
	},
	createScheduleBody: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.create-schedule-body',
		defaultMessage:
			'Schedules help you determine who is on-call at any given time. They can also contain routing rules, overrides, and rotations.',
		description: 'Text to be displayed when there are no Opsgenie schedules.',
	},
	createScheduleButtonText: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.create-schedule-button-text',
		defaultMessage: 'Create a schedule in Opsgenie',
		description: 'Text of a button to be displayed when there are no Opsgenie schedules.',
	},
	emptyScheduleTitle: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.empty-schedule-title',
		defaultMessage: 'Stay organized with rotations',
		description: 'Title to be displayed when there is a Opsgenie schedule without rotations.',
	},
	emptyScheduleBody: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.empty-schedule-body',
		defaultMessage:
			'Opsgenie admins and team admins can create rotations so people on your team know exactly when they’re on call.',
		description: 'Text to be displayed when there is a Opsgenie schedule without rotations.',
	},
	emptyScheduleButtonText: {
		id: 'opsgenie-schedule.components.opsgenie-schedule-component.empty-schedule-button-text',
		defaultMessage: 'Go to Opsgenie',
		description:
			'Text of a button to be displayed when there is a Opsgenie schedule without rotations.',
	},
});

export default messages;
